(function () {
  "use strict";

  const ROOT_SELECTOR = "[data-kit-set-video]";
  const MOBILE_MQ = "(max-width: 720px)";
  const DEFAULT_EXPANDED_INDEX = 1;

  function getVideos(item) {
    return Array.from(item.querySelectorAll("video"));
  }

  function getSectionVideos(section) {
    return Array.from(section.querySelectorAll("video.kit-set-video__player"));
  }

  function playVideo(video) {
    if (!video) return;
    video.muted = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {});
    }
  }

  function pauseVideo(video) {
    if (!video) return;
    video.pause();
  }

  function pauseAll(section) {
    getSectionVideos(section).forEach(pauseVideo);
  }

  function setExpanded(section, index) {
    const items = Array.from(section.querySelectorAll("[data-video-item]"));
    items.forEach(function (item, itemIndex) {
      const active = itemIndex === index;
      item.classList.toggle("is-expanded", active);
      getVideos(item).forEach(function (video) {
        if (active) {
          playVideo(video);
        } else {
          pauseVideo(video);
        }
      });
    });
  }

  function playAll(section) {
    Array.from(section.querySelectorAll("[data-video-item]")).forEach(function (item) {
      item.classList.remove("is-expanded");
      getVideos(item).forEach(playVideo);
    });
  }

  function unbindObserver(section) {
    if (section.__kitSetVideoObserver) {
      section.__kitSetVideoObserver.disconnect();
      section.__kitSetVideoObserver = null;
    }
  }

  function bindMobileObserver(section) {
    unbindObserver(section);

    var videos = getSectionVideos(section);
    if (videos.length === 0) return;

    if (typeof IntersectionObserver === "undefined") {
      playAll(section);
      return;
    }

    section.__kitSetVideoObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            playVideo(entry.target);
          } else {
            pauseVideo(entry.target);
          }
        });
      },
      { root: null, threshold: 0.35 }
    );

    videos.forEach(function (video) {
      section.__kitSetVideoObserver.observe(video);
    });
  }

  function bindDesktop(section) {
    const media = section.querySelector("[data-video-media]");
    const items = Array.from(section.querySelectorAll("[data-video-item]"));
    if (!media || items.length === 0) return;

    var inView = false;

    const onEnter = function (event) {
      if (!inView) return;
      const item = event.currentTarget;
      const index = items.indexOf(item);
      if (index >= 0) setExpanded(section, index);
    };

    const onLeave = function () {
      if (!inView) return;
      setExpanded(section, DEFAULT_EXPANDED_INDEX);
    };

    items.forEach(function (item) {
      item.addEventListener("mouseenter", onEnter);
    });
    media.addEventListener("mouseleave", onLeave);

    section.__kitSetVideoCleanup = function () {
      items.forEach(function (item) {
        item.removeEventListener("mouseenter", onEnter);
      });
      media.removeEventListener("mouseleave", onLeave);
      section.__kitSetVideoCleanup = null;
    };

    // 进入视口后再播放默认展开项，避免首屏外抢带宽
    if (typeof IntersectionObserver === "undefined") {
      inView = true;
      setExpanded(section, DEFAULT_EXPANDED_INDEX);
      return;
    }

    unbindObserver(section);
    section.__kitSetVideoObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          if (inView) {
            setExpanded(section, DEFAULT_EXPANDED_INDEX);
          } else {
            pauseAll(section);
          }
        });
      },
      { root: null, threshold: 0.25 }
    );
    section.__kitSetVideoObserver.observe(media);
  }

  function applyMode(section) {
    if (typeof section.__kitSetVideoCleanup === "function") {
      section.__kitSetVideoCleanup();
    }
    unbindObserver(section);
    pauseAll(section);

    if (window.matchMedia(MOBILE_MQ).matches) {
      bindMobileObserver(section);
      return;
    }

    bindDesktop(section);
  }

  function initSection(section) {
    if (!section) return;

    applyMode(section);

    if (!section.__kitSetVideoResizeBound) {
      section.__kitSetVideoResizeBound = true;
      let frame = 0;
      window.addEventListener("resize", function () {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          applyMode(section);
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target.querySelector(ROOT_SELECTOR) || event.target.closest(ROOT_SELECTOR));
  });
})();
